import { render, staticRenderFns } from "./UserAddressDetails.vue?vue&type=template&id=76a60d0e&scoped=true&"
import script from "./UserAddressDetails.vue?vue&type=script&lang=ts&"
export * from "./UserAddressDetails.vue?vue&type=script&lang=ts&"
import style0 from "./UserAddressDetails.vue?vue&type=style&index=0&id=76a60d0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a60d0e",
  null
  
)

export default component.exports